 $(document).ready(function() {
    
    var show_data_urls = [
        {
            "1": "spray",
            "2": "shoe-grip",
            "url": "/pages/how-to-use-edge-spray-shoe-grip"
        },
        {
            "1": "spray",
            "2": "football-glove-grip",
            "url": "/pages/how-to-use-edge-spray-football-glove"
        },
        {
            "1": "spray",
            "2": "golf-grip",
            "url": "/pages/how-to-use-edge-spray-golf"
        },
        {
            "1": "wipes",
            "2": "shoe-grip",
            "url": "/pages/how-to-use-edge-wipes-shoe-grip"
        },
        {
            "1": "wipes",
            "2": "football-glove-grip",
            "url": "/pages/how-to-use-edge-wipes-football-glove"
        },
        {
            "1": "mat",
            "2": "shoe-grip",
            "url": "/pages/how-to-use-edge-shoe-grip-mat"
        },
        {
            "1": "mat",
            "2": "football-glove-grip",
            "url": "/pages/how-to-use-edge-shoe-grip-mat-football"
        },
        {
            "1": "wipes",
            "2": "golf-grip",
            "url": "/pages/how-to-use-edge-wipes-golf"
        }
    ];

    var urlParams = new URLSearchParams(window.location.search);
    
        var currentPath = window.location.pathname;
        var match = show_data_urls.find(function(item){
            return item.url === currentPath;
        });

        if (match == undefined || match == null) {
            currentPath = '/pages/' + currentPath.split('/pages/')[1];
            match = show_data_urls.find(function(item){
                return item.url === currentPath;
            });
        }
        console.log('match', match);

        if(match){
              console.log('match', " inside");
            $('[data-selectors] .step_select_1').val(match["1"]).trigger('change');
            $('[data-selectors] .step_select_2').val(match["2"]).trigger('change');
            setTimeout(() => {
                $('.how_to_use_loader').hide();                
            }, 1000);
            
            $('.template_how_to_use_selection main .shopify-section').show();
            $('.step').removeClass("active")
            $('.step-3').addClass("active");
            sessionStorage.setItem('step',"step-3");

            if($(window).width() >= 768) {
                $('.how_to_use_selection').remove();
            } else {
                $('.video_text--wrp .step-3.step').remove();
            }

            if($('.review_caurosals').length > 0){
                if ($('.review_caurosals.slick-initialized').length > 0) {
                    $(".review_caurosals").slick("unslick");
                }
                $(".review_caurosals").slick({
                slidesToShow: 3.1,
                slidesToScroll: 1,
                infinite: true,
                speed: 100,
                swipeToSlide: true,
                waitForAnimate: false,
                touchThreshold: 100,
                centerMode: false,
                arrows: true,
                cssEase: 'linear',
                variableWidth: false,
                autoplay: $('.review_caurosals').attr("data-autoplay") == 'false'? false : true,
                autoplaySpeed: $('.review_caurosals').attr("data-autoplay_speed"),
                dots: true,
                appendDots: $('.review_caurosals_slick_buttons .caurosal_dots'),
                prevArrow: $('.review_caurosals_slick_buttons .prev_button'),
                nextArrow: $('.review_caurosals_slick_buttons .next_button'),
                responsive: [
                {
                    breakpoint: 991,
                    settings: {
                    slidesToShow: 2.2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                    slidesToShow: 1.2
                    }
                }
                ]
                });
                $('.review_caurosals_slick_buttons .caurosal_dots ul.slick-dots li').css("width",($('.review_caurosals_slick_buttons .caurosal_dots').width()/$('.review_caurosal_card').length)+"px");
            }
        } else if($('body').hasClass("template_how_to_use_selection_shoe_grip_mat")) {
            $('.template_how_to_use_selection main .shopify-section').show();
            
             $('.step').removeClass("active")
            $('.step-3').addClass("active");
            sessionStorage.setItem('step',"step-3");

            if($(window).width() >= 768) {
                $('.how_to_use_selection').remove();
            } else {
                $('.video_text--wrp .step-3.step').remove();
            }

            if($('.review_caurosals').length > 0){
                if ($('.review_caurosals.slick-initialized').length > 0) {
                    $(".review_caurosals").slick("unslick");
                }
                $(".review_caurosals").slick({
                slidesToShow: 3.1,
                slidesToScroll: 1,
                infinite: true,
                speed: 100,
                swipeToSlide: true,
                waitForAnimate: false,
                touchThreshold: 100,
                centerMode: false,
                arrows: true,
                cssEase: 'linear',
                variableWidth: false,
                autoplay: $('.review_caurosals').attr("data-autoplay") == 'false'? false : true,
                autoplaySpeed: $('.review_caurosals').attr("data-autoplay_speed"),
                dots: true,
                appendDots: $('.review_caurosals_slick_buttons .caurosal_dots'),
                prevArrow: $('.review_caurosals_slick_buttons .prev_button'),
                nextArrow: $('.review_caurosals_slick_buttons .next_button'),
                responsive: [
                {
                    breakpoint: 991,
                    settings: {
                    slidesToShow: 2.2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                    slidesToShow: 1.2
                    }
                }
                ]
                });
                $('.review_caurosals_slick_buttons .caurosal_dots ul.slick-dots li').css("width",($('.review_caurosals_slick_buttons .caurosal_dots').width()/$('.review_caurosal_card').length)+"px");
            }
            document.querySelector('.how_to_use_loader').style.display = "none";
        }

        if((sessionStorage.getItem('show') == 'all' && sessionStorage.getItem('step') == 'step-3') || urlParams.get('show') === 'all'){
    } else {
        document.querySelector('.how_to_use_loader').style.display = "none";
    }


    $('body').on('click', ".js_step_btn", function (e) {
        e.preventDefault();
        document.querySelector('.how_to_use_loader').style.display = "flex";

        var value = $(this).attr("data-value");
        var closest_step = $(this).closest(".step");
        // $('.step').removeClass("active");
        // closest_step.next(".step").addClass("active");
        var step_index = closest_step.attr("data-step");
        $('.step_select_'+step_index).val(value).prop("selected",true).trigger('change');
        $('.step_select_'+step_index).find(`option[value="${value}"]`).attr("selected", "selected").prop("selected",true);
        sessionStorage.setItem('step',`step-${parseInt(step_index)+1}`);
        sessionStorage.setItem('step_select_1',$('.step_select_1').val());
        sessionStorage.setItem('step_select_2',$('.step_select_2').val());

        var match = show_data_urls.find(function(item){
            return item["1"] == $('.step_select_1').val() && item["2"] == value;
        });

        if(match){
            window.location.href = match.url.replace('/pages/','');
        }
    });


    $('body').on('click', ".step_header .js_back", function (e) {
        e.preventDefault();
        var step = $(this).attr("data-back");
        var closest_step = $(this).closest(".step");
        $('.step').removeClass("active");
        closest_step.prev(".step").addClass("active");
        $('.template_how_to_use_selection main .shopify-section:not(:first-child)').hide();
        sessionStorage.setItem('step',`step-${step}`);
        
        sessionStorage.setItem('step_select_1',$('.step_select_1').val());
        sessionStorage.setItem('step_select_2',$('.step_select_2').val());        
    });

 
    $('body').on("change","[data-selectors] select",function (e){
        var step_select_1 = $('[data-selectors] .step_select_1').val();
        var step_select_2 = $('[data-selectors] .step_select_2').val();
        if($('.step-3').hasClass("active")){
            document.querySelector('.how_to_use_loader').style.display = "flex";
        }

        
        sessionStorage.setItem('step_select_1',$('.step_select_1').val());
        sessionStorage.setItem('step_select_2',$('.step_select_2').val());

        if(step_select_1 == 'mat') {
            $('.step_select_2 option[value="golf-grip"]').prop('disabled', true);
        } else {
            $('.step_select_2 option[value="golf-grip"]').prop('disabled', false);
        }

        if(step_select_2 == 'golf-grip') {
            $('.step_select_1 option[value="mat"]').prop('disabled', true);
        } else {
            $('.step_select_1 option[value="mat"]').prop('disabled', false);
        }

        console.log(' ', step_select_1, " ", step_select_2, " ssssss");
        
        var match = show_data_urls.find(function(item){
            return item["1"] == step_select_1 && item["2"] == step_select_2;
        });

        if(match && $('.step-3').hasClass("active")){
            sessionStorage.setItem('show',"all");
            // window.location.href = match.url+'?show=all';
            window.location.href = match.url.replace('/pages/','');
        }
        
    });

    var step_select_1 = $('[data-selectors] .step_select_1').val();
    if(step_select_1 == 'mat') {
        $('.step_select_2 option[value="golf-grip"]').prop('disabled', true);
    } else {
        $('.step_select_2 option[value="golf-grip"]').prop('disabled', false);
    }

    var step_select_2 = $('[data-selectors] .step_select_2').val();
    if(step_select_2 == 'golf-grip') {
        $('.step_select_1 option[value="mat"]').prop('disabled', true);
    } else {
        $('.step_select_1 option[value="mat"]').prop('disabled', false);
    }

    $('body').on("change",".first_step_select_1",function (e){
        var step_select_1_value = $(this).val();
        $('.step_select_1').val(step_select_1_value).prop("selected",true);
        document.querySelector('.how_to_use_loader').style.display = "none";
        
        sessionStorage.setItem('step_select_1',$('.step_select_1').val());
        sessionStorage.setItem('step_select_2',$('.step_select_2').val());
    });
    
});
